/**
 * Langues du sélecteur (aligné sur le portail PDI).
 * Persistance : `voyageur_lang` ; lecture de repli : `pdi_lang` (clé PDI).
 */
export const VOYAGEUR_LANG_KEY = "voyageur_lang"
export const PDI_LANG_FALLBACK_KEY = "pdi_lang"

export const VOYAGEUR_SUPPORTED_LANGS = [
  "fr-FR",
  "fr-BE",
  "en-FR",
  "en-BE",
  "en-NL",
  "it-IT",
  "pt-PT",
  "es-ES",
  "nl-NL",
  "nl-BE"
]

export function normalizeVoyageurLangCode(raw) {
  if (raw == null || raw === "") return null
  const token = String(raw).trim()
  return VOYAGEUR_SUPPORTED_LANGS.includes(token) ? token : null
}

export function getSessionVoyageurLang() {
  try {
    const primary = normalizeVoyageurLangCode(sessionStorage.getItem(VOYAGEUR_LANG_KEY))
    if (primary) return primary
    return normalizeVoyageurLangCode(sessionStorage.getItem(PDI_LANG_FALLBACK_KEY))
  } catch {
    return null
  }
}

export function resolveOptinsByLanguage(rawOptins, selectedLanguage, tunnelDataOptins) {
  if (!rawOptins?.length) return rawOptins

  const filterByLanguage = (language) => {
    const normalized = normalizeVoyageurLangCode(language)
    if (!normalized) return []
    return rawOptins.filter((optin) => normalizeVoyageurLangCode(optin.language) === normalized)
  }

  const filtered = filterByLanguage(selectedLanguage)
  if (filtered.length > 0) return filtered

  const fallbackSource = tunnelDataOptins?.length ? tunnelDataOptins : rawOptins
  return filterByLanguage(fallbackSource[0]?.language)
}
